import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../Button';
import Popup from '../Popup';
import './styles.css';

class Tooltip extends React.PureComponent {
  static propTypes = {
    contentHeader: PropTypes.string,
    contentText: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.arrayOf(PropTypes.string),
    ]),
    position: PropTypes.string,
    showCloseBtn: PropTypes.bool,
    showOnHover: PropTypes.bool,
    onClose: PropTypes.func,
    popupClassName: PropTypes.string,
    contentClassName: PropTypes.string,
  };

  containerRef = null;

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.containerRef = React.createRef();
  }

  focusTooltip = () => {
    this.containerRef.current.focus({
      preventScroll: true,
    });
  };

  toggleTooltip = () => {
    this.setState(
      ({ isOpen }) => ({
        isOpen: !isOpen,
      }),
      (state) => {
        if (this.state.isOpen) {
          this.focusTooltip();
        } else {
          const { onClose } = this.props;
          if (onClose) {
            onClose();
          }
        }
      },
    );
  };

  getContentText = () => {
    const { contentText } = this.props;

    if (contentText) {
      if (Array.isArray(contentText)) {
        return (
          <div data-cy="tooltip-content-text" className="tooltip-content-text">
            {contentText.map((item, index) => (
              <p key={`${item}_${index}`}>{item}</p>
            ))}
          </div>
        );
      } else {
        return (
          <p data-cy="tooltip-content-text" className="tooltip-content-text">
            {contentText}
          </p>
        );
      }
    }
  };

  getTooltipContent = () => {
    const { contentHeader, contentClassName, showCloseBtn } = this.props;
    return (
      <div
        data-cy="tooltip-content-container"
        className={classNames('tooltip-content-container', contentClassName)}
        aria-label={contentHeader}
        tabIndex="1"
        ref={this.containerRef}
      >
        {showCloseBtn && (
          <Button
            icon="close"
            tabIndex="1"
            className="tooltip-close-btn"
            onClick={this.toggleTooltip}
          />
        )}
        {contentHeader && <h5 className="tooltip-content-heading">{contentHeader}</h5>}
        {this.getContentText()}
      </div>
    );
  };

  render() {
    const { children, position, showOnHover, popupClassName } = this.props;
    return (
      <Popup
        className={classNames('hubs-basic-tooltip', popupClassName)}
        on={showOnHover ? 'hover' : 'click'}
        pinned
        inverted
        position={position || 'bottom center'}
        content={this.getTooltipContent()}
        trigger={children}
        open={this.state.isOpen}
        onOpen={this.toggleTooltip}
        onClose={this.toggleTooltip}
      />
    );
  }
}

export default Tooltip;
